import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../../const/colors/staticColors';
import { sizes } from '../../../const/sizes';
import { transitionDuration } from '../../../const/transitionDuration';
import { useTestIdAttribute } from '../../../hooks/useTestIdAttribute';
import { Icon } from '../../Icon/Icon';
import { Text } from '../../Text/Text';
import { Tooltip } from '../../Tooltip/Tooltip';
import { FlexContainer } from '../../layout/FlexContainer';
import { navigationVerticalItemShadow } from './navigationVerticalConst';
const StyledNavigationVerticalItem = styled('div', ({ $isActive, $isDisabled }) => {
    const showDefaultColor = $isActive || $isDisabled;
    const color = staticColors.navigationVerticalItemTextColor;
    const hoverColor = showDefaultColor
        ? color
        : staticColors.navigationVerticalItemHoverTextColor;
    const activeColor = showDefaultColor
        ? color
        : staticColors.navigationVerticalItemActiveTextColor;
    const isActiveAndNotDisabled = $isActive && !$isDisabled;
    const backgroundColor = isActiveAndNotDisabled
        ? staticColors.navigationVerticalItemSelectedBackground
        : 'transparent';
    const boxShadow = $isActive
        ? navigationVerticalItemShadow
        : 'none';
    const hoverCursor = $isDisabled
        ? 'not-allowed'
        : 'pointer';
    return {
        backgroundColor,
        boxShadow,
        borderRadius: sizes.navBarHorizontal.borderRadius,
        width: '100%',
        transitionProperty: 'background-color',
        transitionDuration: transitionDuration.medium,
        transitionTimingFunction: 'linear',
        cursor: hoverCursor,
        color,
        ':hover': {
            color: hoverColor,
        },
        ':active': {
            color: activeColor,
        },
    };
});
export const NavigationVerticalItem = ({ isActive, isDisabled = false, isTransparent = false, isLabelHidden = false, label, iconName, testId, afterElement, afterIconName, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const disabledColor = isDisabled
        ? staticColors.navigationVerticalItemDisabledTextColor
        : undefined;
    const transparentColor = isTransparent ? staticColors.textAction : undefined;
    const textColorOverride = disabledColor ?? transparentColor ?? 'unset';
    const isActiveOrTransparent = isActive || isTransparent;
    const isActiveOrTransparentAndNotDisabled = isActiveOrTransparent && !isDisabled;
    const iconColor = isActiveOrTransparentAndNotDisabled
        ? 'action'
        : 'greyLight';
    const activeVariant = isActiveOrTransparentAndNotDisabled
        ? 'h6'
        : 'b2';
    const maybeIcon = iconName ? (_jsx(Icon, { name: iconName, color: iconColor })) : undefined;
    const maybeAfterIcon = afterIconName ? (_jsx(Icon, { name: afterIconName, colorOverride: textColorOverride })) : undefined;
    const maybeLabel = !isLabelHidden && (_jsxs(_Fragment, { children: [_jsx(Text, { variant: activeVariant, colorOverride: textColorOverride, children: label }), maybeAfterIcon, afterElement] }));
    const item = (_jsx(StyledNavigationVerticalItem, { $isActive: isActive, $isDisabled: isDisabled, $isTransparent: isTransparent, ...testIdAttribute, children: _jsxs(FlexContainer, { direction: 'row', verticalAlign: 'center', spacingVertical: true, gap: true, spacingHorizontal: true, children: [maybeIcon, maybeLabel] }) }, label));
    if (isLabelHidden) {
        return (_jsx(Tooltip, { text: label, asChild: true, children: item }));
    }
    return item;
};
